<!-- Change log Progress Spinner Start-->
<p-overlayPanel #hoverOverProgressSpinner appendTo="body" [dismissable]="false" [showCloseIcon]="false"> 
  <div class="ui-progressSpinner">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="1" *ngIf="loading"></p-progressSpinner>
  </div>  
</p-overlayPanel>
<!-- Change log Progress Spinner End-->
<!-- Change log HoverOver Popup  Start-->
<p-overlayPanel #hoverOverDataContainer appendTo="body" [dismissable]="false" [showCloseIcon]="false">
  <div class="change-history" *ngIf="!loading">
    <h2>{{changelog.Title}}</h2>
    <table>
      <tr>
        <th *ngFor="let header of changelog.DataHeaders">{{header.Value}}</th>          
      </tr>
      <tr *ngFor="let data of changelog.DataRows">
        <td *ngFor="let row of data.Rows">{{row.Value}}</td>
      </tr>
    </table>
  </div>
</p-overlayPanel>
<!-- Change log HoverOver Popup  End-->
